// Central asset registry — swap logo / images here in one place.

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_f11b1fb6-7e1d-43e7-a778-6dbcb85564b5/artifacts/40qs1hdx_Trust%20F%26I%20logo%20colour.png";

export const CAP_STATEMENT_PDF =
  "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/a77l32xi_New%20Trust%20Flooring%20Cap%20Statement.pdf";

export const WHATSAPP_URL = "https://wa.me/64223675122";

export const IMAGES = {
  hero: "https://customer-assets.emergentagent.com/job_f11b1fb6-7e1d-43e7-a778-6dbcb85564b5/artifacts/kzuhz4qa_L22SD_IMAGEWORKS-15.webp.jpeg",
  residentialWarm:
    "https://customer-assets.emergentagent.com/job_f11b1fb6-7e1d-43e7-a778-6dbcb85564b5/artifacts/ontmqmdq_0C6A8316-16.webp",
  minimalLiving:
    "https://customer-assets.emergentagent.com/job_f11b1fb6-7e1d-43e7-a778-6dbcb85564b5/artifacts/4zmopd95_OTOH_Gibbons_FiveMile_Int_Living_Final01%2B%283%29.webp",
  commercialHall:
    "https://images.pexels.com/photos/33685849/pexels-photo-33685849.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  floorPrep:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/pvmjx55m_floor%20preperation.jpg",
  plastering:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/qau2vrv9_Artisan%20plastering.JPG",
  tiling:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/i78i62r8_IMG_20220216_142456.jpeg",
  teamMartin:
    "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  teamMiguel:
    "https://images.unsplash.com/photo-1758518729314-b02874db8c37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdCUyMHBvcnRyYWl0JTIwbWFuJTIwb2ZmaWNlfGVufDB8fHx8MTc3NzUwMDkxM3ww&ixlib=rb-4.1.0&q=85",
  // Extra placeholders for projects/services
  flooringDetail:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/69e379u4_Flooring.jpg",
  interiorFinishing:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/ru46byio_d1006811-2088-4496-9f26-703936094a49.JPG",
  waterproofing:
    "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/3esgidey_Waterproofing.webp",
  commercialOffice:
    "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&w=1600&q=80",
  residentialBath:
    "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?auto=format&fit=crop&w=1600&q=80",
};

export const CONTACT = {
  emailPrimary: "martin@trustflooring.co.nz",
  emailSubmissions: "miguel@trustflooring.co.nz",
  phoneMartin: "021 430 559",
  phoneMiguel: "022 367 5122",
  aucklandAddress: "28 Constellation Drive, Auckland",
  christchurchAddress: "Christchurch — TBC",
  queenstownAddress: "Queenstown — TBC",
  whatsapp: WHATSAPP_URL,
  facebook: "https://www.facebook.com/trustflooringandinteriors",
  instagram: "https://www.instagram.com/trust_flooring_nz",
};

export const LOCATIONS = [
  {
    name: "Auckland",
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/x596cmiz_auckland.jpg",
  },
  {
    name: "Christchurch",
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/rrty98t1_christchurch.jpg",
  },
  {
    name: "Queenstown",
    image:
      "https://customer-assets.emergentagent.com/job_trust-nz-build/artifacts/p8zbklw8_queenstown.jpg",
  },
];
